import { CostingItem, LineItem, Operation } from "../../interfaces/app_types";

// Staged and historical items may contain only the saved operations/assembly.
export const prepareCostingItem = (item: CostingItem): CostingItem => {
  const lineItems: LineItem[] = item.lineItems?.length
    ? item.lineItems.map((line) => ({ ...line }))
    : [
        ...(item.operations ?? []).map(
          (op): LineItem => ({
            ...op,
            type: op.custom ? "custom_op" : "op",
          })
        ),
        ...(item.assembly ?? []).map(
          (assembly): LineItem => ({
            ...assembly,
            type: "assembly",
          })
        ),
      ];

  return {
    ...item,
    operations: (item.operations ?? []).map((op) => ({ ...op })),
    assembly: (item.assembly ?? []).map((assembly) => ({ ...assembly })),
    tools: (item.tools ?? []).map((tool) => ({ ...tool })),
    lineItems,
  };
};

export const moveCostingItem = (
  items: CostingItem[],
  from: number,
  to: number
): CostingItem[] => {
  if (
    from === to ||
    from < 0 ||
    to < 0 ||
    from >= items.length ||
    to >= items.length
  ) {
    return items;
  }
  const reordered = [...items];
  const [item] = reordered.splice(from, 1);
  reordered.splice(to, 0, item);
  return reordered;
};

export const addOperationsToItems = (
  items: CostingItem[],
  indices: number[],
  operations: Operation[]
): CostingItem[] => {
  const selected = new Set(indices);
  return items.map((item, index) => {
    if (!selected.has(index) || !operations.length) return item;
    const prepared = prepareCostingItem(item);
    return {
      ...prepared,
      operations: [
        ...(prepared.operations ?? []),
        ...operations.map((op) => ({ ...op })),
      ],
      lineItems: [
        ...(prepared.lineItems ?? []),
        ...operations.map(
          (op): LineItem => ({ ...op, type: op.custom ? "custom_op" : "op" })
        ),
      ],
    };
  });
};
